module.exports = __webpack_public_path__ + "img/y10.08e7de71.jpg";